import styled from 'styled-components';

const Wrapper = styled.div`
  &.hide {
    display: none;
  }
  // Hide on mobile while persistent footer is in use
  @media(max-width: 45em) {
    display: none;
  }
`;

export default Wrapper;
